export default __webpack_public_path__ + "static/media/recordx-project.ae44b6ae.jpeg";